<div class="statement-preview">
  <div *ngIf="noValidEmails || showAlert" class="alert alert--error p-2 d-flex align-items-center justify-content-center">
    {{
      noValidEmails
        ? 'There are no valid recipients for this statement. Please ensure your PM System has correct contact information, including who should receive these statements.'
        : 'Email could not be sent. Please fix the errors below.'
    }}
  </div>
  <form [formGroup]="statementForm">
    <div class="statement-row p-3">
      <div class="d-flex align-items-center">
        <span class="statement-label">From:</span>
        <input
          type="email"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': statementForm.controls['from'].invalid && statementForm.controls['from'].touched }"
          formControlName="from"
        />
      </div>
      <!-- <mat-error class="ms-3">required</mat-error> -->
    </div>
    <div class="statement-correspondence d-flex flex-row p-3">
      <div class="statement-row me-6 col d-flex flex-row align-items-center">
        <span class="statement-label flex-shrink-1">To:</span>
        <input
          type="email"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': statementForm.controls['to'].invalid && statementForm.controls['to'].touched }"
          formControlName="to"
        />
      </div>
      <div class="statement-row me-6 col d-flex flex-row align-items-center">
        <span class="statement-label flex-shrink-1">Cc:</span>
        <input
          type="email"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': statementForm.controls['ccList'].invalid && statementForm.controls['ccList'].touched }"
          formControlName="ccList"
        />
      </div>
      <div class="statement-row me-6 col d-flex flex-row align-items-center">
        <span class="statement-label flex-shrink-1">Bcc:</span>
        <input
          type="email"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': statementForm.controls['bccList'].invalid && statementForm.controls['bccList'].touched }"
          formControlName="bccList"
        />
      </div>
    </div>
    <div class="statement-row p-3 d-flex align-items-center">
      <span class="statement-label flex-shrink-1">Subject:</span>
      <input
        class="form-input"
        [ngClass]="{ 'form-input--invalid': statementForm.controls['subject'].invalid && statementForm.controls['subject'].touched }"
        formControlName="subject"
      />
    </div>
    @if (mode === 'Edit') {
      <div class="p-3">
        <div class="mb-2">
          <span class="">Headline:</span>
          <app-template-rich-text-editor id="headline-rich-text-editor" class="my-1" [control]="headlineControl" />
          <p class="small-400">Appears at the top of the statement email message body.</p>
        </div>
        <div class="mt-4">
          <span class="">Message:</span>
          <app-template-rich-text-editor id="body-rich-text-editor" class="my-1" [control]="bodyControl" />
          <p class="small-400">The message appears near the top of the statement email body.</p>
        </div>
      </div>
    }
  </form>
  <div class="email-preview-container py-6">
    <ng-container *ngIf="!previewLoading">
      <div *ngIf="emailPreview; else noPreviewTemplate" class="email-preview" [innerHtml]="emailPreview"></div>
      <ng-template #noPreviewTemplate><p>Email preview not available</p></ng-template>
    </ng-container>

    <ng-container *ngIf="previewLoading">
      <mat-spinner class="mx-auto m-4" />
    </ng-container>
  </div>

  <!-- attachments -->
  @let _canEditAndSendStatements = canEditAndSendStatements();
  <div *ngIf="attachmentsDisplay?.length" class="attachment-info p-3 d-flex align-items-center">
    <div
      *ngFor="let attachment of attachmentsDisplay; let idx = index"
      class="attachment-item d-flex align-items-center ps-2 pe-1 py-1 me-2"
      [ngClass]="attachment.gcsFilePath ? 'bg-color-green-1000' : 'bg-color-gray-1000'"
    >
      <span>{{ attachment?.display || attachment?.name }}</span>
      <div [tooltipEnabled]="!_canEditAndSendStatements" tooltip="You do not have permission to edit statements.">
        <button
          *ngIf="mode === 'Edit'"
          class="d-flex align-items-center ms-1"
          [disabled]="!_canEditAndSendStatements"
          (click)="_canEditAndSendStatements && handleRemoveAttachment(idx, attachment)"
        >
          <anduin-icon name="x" fill="none" stroke="currentColor" />
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="mode === 'Edit'" class="statement-controls p-4 d-flex justify-content-between">
    <div class="action-group d-flex">
      <div [tooltipEnabled]="!_canEditAndSendStatements" tooltip="You do not have permission to edit or send statements.">
        <button
          class="me-4"
          [disabled]="!!currentActionProcessing() || !_canEditAndSendStatements"
          (click)="_canEditAndSendStatements && attachmentInput.click()"
          andButton
          color="ghost-secondary"
        >
          <anduin-icon name="paperclip" class="me-2" fill="none" stroke="currentColor" />
          Add Attachment
        </button>
        <input #attachmentInput type="file" class="d-none" (input)="handleAttachments(attachmentInput.files, attachmentInput)" multiple />
      </div>

      <div [tooltipEnabled]="!_canEditAndSendStatements" tooltip="You do not have permission to edit or send statements.">
        <button
          [disabled]="currentActionProcessing() && currentActionProcessing() !== SmartStatementAction.TEST || !_canEditAndSendStatements"
          [isLoading]="currentActionProcessing() === SmartStatementAction.TEST"
          (click)="_canEditAndSendStatements && handleSendTestEmail()"
          andButton
          color="ghost-secondary"
        >
          <anduin-icon name="send" class="me-2" fill="none" stroke="currentColor" />
          Send Myself a Test
        </button>
      </div>
    </div>

    <div class="d-flex">
      <div [tooltipEnabled]="!_canEditAndSendStatements" tooltip="You do not have permission to edit or send statements.">
        <button
          class="me-4"
          [disabled]="currentActionProcessing() && currentActionProcessing() !== SmartStatementAction.SKIP || !_canEditAndSendStatements"
          [isLoading]="currentActionProcessing() === SmartStatementAction.SKIP"
          (click)="_canEditAndSendStatements && onSkip()"
          andButton
          color="secondary"
        >
          Skip Statement
        </button>
      </div>

      <div [tooltipEnabled]="!_canEditAndSendStatements" tooltip="You do not have permission to edit or send statements.">
        <button
          [disabled]="currentActionProcessing() && currentActionProcessing() !== SmartStatementAction.SEND || !_canEditAndSendStatements"
          [isLoading]="currentActionProcessing() === SmartStatementAction.SEND"
          (click)="_canEditAndSendStatements && onApprove()"
          andButton
          color="primary"
        >
          Approve and Send
        </button>
      </div>
    </div>
  </div>
</div>
